module.exports = ".row {\n    cursor: pointer;\n  }\n  \n  .row:hover {\n    background-color: #F8F8F8;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/detail/detail.css
// module id = ./src/app/components/detail/detail.css
// module chunks = main